<template lang="pug">
div(:style="'min-height:' + h")
  .px-0.white.detail-head.head-border
    el-row.pl-5
      el-col(:span="8")
        Breadcrumb
      el-col.pt-5.text-right(:span="15")
        el-button(
          v-if="true",
          type="primary",
          size="mini",
          @click="$router.go(-1)"
        ) 返回
  div(style="height: 70px")
  el-main.white.pa-3.ma-4
    el-table(:data="data", v-loading="loading", size="mini")
      el-table-column(prop="code", label="付款申请单号", width="150")
      el-table-column(prop="purchase_org_name", label="采购组织", width="150")
      el-table-column(prop="pk_supplier_name", label="供应商", width="180")
      el-table-column(prop="payment_method_name", label="付款方式", width="120")
      el-table-column(prop="bill_no", label="票据号", width="130")
      el-table-column(prop="bill_info", label="票据信息", width="130")
      el-table-column(prop="money", label="金额", width="100")
      el-table-column(prop="free_4", label="所属公司", width="100")
      el-table-column(prop="free_2", label="承兑人名称", width="100")
      el-table-column(prop="free_3", label="银行等级", width="70")
      el-table-column(prop="free_1", label="票据到期日", width="100")
      el-table-column(prop="free_5", label="背书次数", width="68")
      el-table-column(prop="free_6", label="票据种类", width="68")
      el-table-column(prop="status", label="状态", width="100")
        template(slot-scope="scope")
          span {{ scope.row.status == 0 ? "待支付" : "" }}
          span {{ scope.row.status == 1 ? "待签收" : "" }}
          span {{ scope.row.status == 2 ? "成功" : "" }}
          span {{ scope.row.status == 3 ? "失败" : "" }}
          span {{ scope.row.status == 4 ? "作废" : "" }}
          span {{ scope.row.status == 5 ? "暂停" : "" }}
      el-table-column(prop="pay_act_date", label="支付日期", width="160") 
      el-table-column(prop="pay_note", label="支付说明", width="200") 
      el-table-column(label="操作", width="300")
        template(slot-scope="scope")
          el-button(
            v-if="head.status == 2",
            v-show="scope.row.status==0 || scope.row.status==5",
            size="mini",
            type="primary",
            plain,
            @click="statusedit(scope.row, 'A')"
          ) 作废
          el-button(
            v-show="scope.row.status==0 && head.status==2",
            size="mini",
            type="primary",
            plain,
            @click="statusedit(scope.row, 'B')"
          ) 暂停
          el-button(
            v-show="scope.row.status==5 && head.status==2",
            size="mini",
            type="primary",
            plain,
            @click="statusedit(scope.row, 'C')"
          ) 取消暂停
    el-pagination.my-4.text-center(
      @size-change="handleSizeChange",
      @current-change="handleCurrentChange",
      :current-page="list.page_num",
      :page-sizes="page_sizes",
      :page-size="list.page_size",
      layout="total, sizes, prev, pager, next, jumper",
      :total="count",
      background
    ) 
</template>
<script>
export default {
  data() {
    return {
      h: "",
      head: null,
      title: "新增",
      loading: false,
      data: [],
      dialogFormVisible: false,
      count: 0,
      list: {
        page_num: 1,
        page_size: 10,
      },
      loadingSupply: false,
      path: this.$api.pricedata.import_file,
      supply: [],
      disabled: false,
    };
  },
  computed: {
    getPk() {
      return { pk_guide: this.id };
    },
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    type: {
      type: [Number, String],
      default: 1,
    },
  },

  methods: {
    handleSizeChange(e) {
      this.list.page_size = e;
      this.$router.push({
        path: this.$route.path,
        query: this.list,
      });
    },
    beforeUpload() {
      this.loading = true;
      return true;
    },
    handleSuccess(res) {
      this.loading = false;
      if (res.code == 200) {
        this.getPayList;
      } else {
        this.$notify({
          message: res.msg,
          type: "error",
        });
      }
    },
    handleCurrentChange(e) {
      this.list.page_num = e;
      this.$router.push({
        path: this.$route.path,
        query: this.list,
      });
    },
    init() {
      let data = this.$route.query;
      if (data) {
        this.list = this.$utils.cloneDeep(data);
        if (data.page_num) {
          this.list.page_num = parseInt(data.page_num);
        }
        if (data.page_size) {
          this.list.page_size =
            this.page_sizes.indexOf(parseInt(data.page_size)) > -1
              ? parseInt(data.page_size)
              : this.page_sizes[0];
        }
      }
      this.getPayList();
    },
    async statusedit(e, method) {
      this.loading = true;
      var res;
      if (this.head.platform_flag == 1) {
        res = await this.$api.purchase_payment.statusEditNew(method, e);
      } else {
        res = await this.$api.purchase_payment.statusEdit(method, e);
      }
      this.loading = false;
      if (res) {
        this.$notify({
          message: "操作成功",
          type: "success",
        });
        this.getPayList();
      }
    },
    async getPayList() {
      this.loading = true;
      let res = await this.$api.purchase_payment.getPayList(this.id, this.list);
      this.loading = false;
      if (res) {
        this.data = res.data;
        this.count = res.count;
      }
    },
    async getById() {
      this.loading = true;
      let res = await this.$api.purchase_payment.getListDetail(this.id);
      this.loading = false;
      if (res) {
        this.data = res.data;
        this.head = this.data.head;
      }
      if (this.head.buyer_code == this.user.pk_psndoc) {
        this.buyertype = "1";
      }
    },
  },
  mounted() {
    this.h = document.body.clientHeight - 61 + "px";
  },
  created() {
    this.getPayList();
    this.getById();
  },
  watch: {
    $route: {
      handler: "init",
      immediate: true,
    },
  },
};
</script>